import AllGames from "./AllGames.vue";
export default AllGames;